'use client';

import Script from 'next/script';

/**
 * Reddit Pixel — base code
 * Fires a 'PageVisit' event on every page load automatically.
 * Pixel ID belongs to the Open.cx Reddit Ads account.
 *
 * Consent-gated: only mounted by TrackingScripts when the visitor's
 * marketing consent is granted. Do not mount this anywhere else.
 */
const REDDIT_PIXEL_ID = 'a2_jbd68i6xxcpn';

export default function RedditPixel() {
  return (
    <Script id="reddit-pixel" strategy="afterInteractive">
      {`
        !function(w,d){
          if(!w.rdt){
            var p=w.rdt=function(){
              p.sendEvent ? p.sendEvent.apply(p,arguments) : p.callQueue.push(arguments)
            };
            p.callQueue=[];
            var t=d.createElement("script");
            t.src="https://www.redditstatic.com/ads/pixel.js";
            t.async=!0;
            var s=d.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(t,s)
          }
        }(window,document);
        rdt('init','${REDDIT_PIXEL_ID}');
        rdt('track','PageVisit');
      `}
    </Script>
  );
}
